import { Directive, OnInit, OnDestroy, inject } from '@angular/core';
import { ToolBarButtonComponent } from '@progress/kendo-angular-toolbar';
import { EditorComponent } from '@progress/kendo-angular-editor';
import { DialogService } from '@app/services';
import { Subscription } from 'rxjs';
import { InsertImageModalComponent } from '@app/pages/main/pages/quality/components/shared/editor/modals/insert-image-modal/insert-image-modal.component';

@Directive({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'kendo-toolbar-button[insertImageDirective]',
})
export class InsertImageDirective implements OnInit, OnDestroy {
  private button = inject(ToolBarButtonComponent);
  private dialogService = inject(DialogService);
  private editor = inject(EditorComponent, { host: true });

  readonly strings = tiStrings.modules.quality.incidents;
  private sub = new Subscription();

  ngOnInit(): void {
    this.button.icon = 'image';
    this.button.text = this.strings.insertImage;
    this.sub.add(
      this.button.click.subscribe(() => {
        this.openModal();
      }),
    );

    this.sub.add(
      this.editor.stateChange.subscribe(() => {
        const isDisabled = this.editor.isReadonly;
        if (this.button.disabled !== isDisabled) {
          this.button.disabled = isDisabled;
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.sub && this.sub.unsubscribe();
  }
  private openModal(): void {
    this.dialogService.showDialog(InsertImageModalComponent, (instance, close) => {
      this.sub.add(instance.close$.subscribe((result) => close(result)));
      instance.editor = this.editor;
    });
  }
}
